import { getDeviceType } from "../../../utilities/getDeviceType";

/**
 * Adventure map needs horizontal room (MapContainer min-width 820px + page padding).
 * Below this viewport width we keep the prod card grid.
 */
export const PROGRAM_MAP_MIN_WIDTH = 1100;

export const shouldUseClassicProgramLayout = (screenWidth) =>
  screenWidth < PROGRAM_MAP_MIN_WIDTH || getDeviceType() === "mobile";
